import { render, staticRenderFns } from "./WebshopSettingItem.vue?vue&type=template&id=af765df8&"
import script from "./WebshopSettingItem.vue?vue&type=script&lang=js&"
export * from "./WebshopSettingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports